import { parse } from 'date-fns';
import React, {useState, useEffect} from 'react'
// reactstrap components
import {
    Card,
    CardTitle,
    CardHeader,
    CardBody,    
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Row,
    Col,
    UncontrolledTooltip,

  } from "reactstrap";


  const baseFormData = [{
    "full_code": "",
    "analytic_number": "",
    "analytic_name": "",
    "extinction_1_number": "",
    "extinction_1_name": null,
    "extinction_2_number": null,
    "extinction_2_name": null,
    "type": "stale",
    "category": "",
    "subcategory": null,
    "group_id": null,
    "group_name": ""
}]

const FourForm = ({four_list, group_code, dataSubmit, notify}) => {
    const [FormData, setFormData] = useState([...baseFormData])

    useEffect(() => {
        setFormData([...four_list])
    }, [four_list])

    const handleFieldChange = (e) => {
        const itemID = parseInt(e.target.id.split('-')[1])
        const itemName = e.target.id.split('-')[0]
        const itemValue = e.target.value
        setFormData((prevState) => {
            let newState = [...prevState]
            newState[itemID][`${itemName}`] = itemValue
            return(newState)
        })
    }

    const handleSubmit = (id) => {
        // e.preventDefault();
        // const itemID = parseInt(e.target.id)
        const itemID = id
        const filtredFormItem = FormData.filter(dataItem => dataItem.id === itemID)[0]

        let itemToSubmit = {}
        Object.keys(baseFormData[0]).map(key =>{
            itemToSubmit[key] = filtredFormItem[key]
        })

        let errorMessage = []
        if(itemToSubmit.analytic_number.length>=3){
            if(!['400','401','402','403','404','405','406'].includes(itemToSubmit.analytic_number.substring(0,3))){
                errorMessage.push('Nieprawidłowy symbol konta.')
            }
        }else{
            errorMessage.push('Zbyt krótki symbol konta.')
        }
        if(itemToSubmit.extinction_1_number && itemToSubmit.extinction_1_number.length>4) errorMessage.push('Zbyt długi numer własny 1.')
        if(itemToSubmit.extinction_2_number && itemToSubmit.extinction_2_number.length>4) errorMessage.push('Zbyt długi numer własny 2.')
        if(itemToSubmit.extinction_1_name && itemToSubmit.extinction_1_name.length>1000) errorMessage.push('Zbyt długa nazwa własna 1.')
        if(itemToSubmit.extinction_2_name && itemToSubmit.extinction_2_name.length>1000) errorMessage.push('Zbyt długa nazwa własna 2.')
        if(errorMessage.length!==0){
            notify(errorMessage.join(' '))
        }else{
            dataSubmit(itemID, itemToSubmit)
        }
    }

    
    return (
        <div style={{margin: '0 15px'}}>
        <Row className={'row-margin'} style={{alignItems: 'flex-end'}} >
            <Col sm={4}>
                <Row className={'text-center'} style={{alignItems: 'flex-end', color:"#595959", fontSize:"0.8571em"}} >
                    <Col sm={3}> Symbol konta </Col>
                    <Col sm={9}> Nazwa analityczna </Col>
                </Row>
            </Col>
            <Col sm={8}>
                <Row className={'row-margin text-center'} style={{alignItems: 'flex-end', color:"#595959", fontSize:"0.8571em"}}>
                    <Col sm={1}> Numer własny 1 </Col>
                    <Col sm={3}> Nazwa własna 1 </Col>
                    <Col sm={1}> Numer własny 2 </Col>
                    <Col sm={3}> Nazwa własna 2 </Col>
                    <Col sm={3}> Rodzaj kosztów </Col>
                    <Col sm={1}> Zapisz </Col>
                </Row>
            </Col>
        </Row>
        {FormData.map((opk_item, opk_idx) => {
                return (
                    <Form key={opk_idx} id={opk_item.id} >
                    <Row className={'row-margin'}>
                        <Col sm={4}>
                            <Row className={''}>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`analytic_number-${opk_idx}`} className='sr-only'>Symbol konta</label>
                                        <Input 
                                            id={`analytic_number-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            disabled={!opk_item.user_added}
                                            value={opk_item.analytic_number}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={9}>
                                    <FormGroup>
                                        <label htmlFor={`analytic_name-${opk_idx}`} className='sr-only'>Nazwa analityczna</label>
                                        <Input 
                                            id={`analytic_name-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}                                            
                                            value={opk_item.analytic_name}
                                            onChange={(e) => handleFieldChange(e)}    
                                        />
                                    </FormGroup>
                                </Col>
                                {/* <Col sm={2}>
                                    <FormGroup>
                                        <Input 
                                        value={opk_item.group_id} 
                                        type="select" 
                                        name="select" 
                                        id={`group_id-${opk_idx}`}
                                        onChange={(e) => handleFieldChange(e)}
                                        >
                                            {group_code.map((groupCodeItem, codeIdx )=>{
                                                return(
                                                    <option key={codeIdx} value={groupCodeItem.id}>{`${groupCodeItem.group_number}`}</option>
                                                )
                                            })}
                                        </Input>
                                    </FormGroup>
                                </Col> */}
                            </Row>
                        </Col>
                        <Col sm={8}>
                            <Row className={'row-margin'}>
                                <Col sm={1}>
                                    <FormGroup>
                                        <label htmlFor={`extinction_1_number-${opk_idx}`} className='sr-only'>Numer własny 1</label>
                                        <Input 
                                            id={`extinction_1_number-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.extinction_1_number}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`extinction_1_name-${opk_idx}`} className='sr-only'>Nazwa własna 1</label>
                                        <Input 
                                            id={`extinction_1_name-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.extinction_1_name}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={1}>
                                    <FormGroup>
                                        <label htmlFor={`extinction_2_number-${opk_idx}`} className='sr-only'>Numer własny 2</label>
                                        <Input 
                                            id={`extinction_2_number-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.extinction_2_number}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`extinction_2_name-${opk_idx}`} className='sr-only'>Nazwa własna 2</label>
                                        <Input 
                                            id={`extinction_2_name-${opk_idx}`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={opk_item.extinction_2_name}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`type-${opk_idx}`} className='sr-only'>Rodzaj kosztów</label>
                                        <Input 
                                            value={opk_item.type} 
                                            type="select" 
                                            name="select" 
                                            id={`type-${opk_idx}`}
                                            onChange={(e) => handleFieldChange(e)}
                                        >
                                            <option value={"stale"}>stale</option>
                                            <option value={"zmienne"}>zmienne</option>
                                            {/* <option value={"brak"}>brak</option> */}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm={1}>
                                    <Row className={'text-center'}>
                                        <Col >
                                            <Button
                                            className="btn-link mr-1"
                                            color="import"
                                            data-toggle="tooltip"
                                            id={`save-${opk_idx}`}
                                            style={{marginTop:"0px"}}
                                            type="button"
                                            onClick={(e) => handleSubmit(opk_item.id)}
                                            aria-label='Zapisz'
                                        >
                                            <i className="far fa-save fa-2x"></i>
                                        </Button>
                                        <UncontrolledTooltip
                                            delay={0}
                                            placement="top"
                                            target={`save-${opk_idx}`}
                                        >
                                            Zapisz
                                        </UncontrolledTooltip>
                                        {/* <Button block type='submit' className={'btn-aotmit-gradient m-0'} style={{minWidth:'100px'}}>
                                            Zapisz
                                        </Button> */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
                )
            })}
        </div>
    )
}

export default FourForm
